import script from './component-lib.esm37.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Apple Podcast'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M7.12 0c-0.005 0-0.010-0-0.016-0-3.923 0-7.104 3.181-7.104 7.104 0 0.006 0 0.011 0 0.017v-0.001 17.76c0 0.005-0 0.010-0 0.016 0 3.923 3.181 7.104 7.104 7.104 0.006 0 0.011 0 0.017-0h17.759c0.005 0 0.010 0 0.016 0 3.923 0 7.104-3.181 7.104-7.104 0-0.006 0-0.011-0-0.017v0.001-17.76c0-0.005 0-0.010 0-0.016 0-3.923-3.181-7.104-7.104-7.104-0.006 0-0.011 0-0.017 0h0.001zM15.82 3.424c3.115 0 5.931 1.203 8.075 3.449 1.632 1.696 2.549 3.492 3.019 5.856 0.16 0.787 0.16 2.933 0.009 3.819-0.527 2.9-2.094 5.363-4.292 7.041l-0.028 0.020c-0.811 0.613-2.795 1.681-3.115 1.681-0.117 0-0.128-0.121-0.075-0.613 0.096-0.789 0.192-0.953 0.64-1.141 0.715-0.299 1.931-1.165 2.677-1.913 1.265-1.264 2.199-2.859 2.662-4.644l0.016-0.071c0.277-1.099 0.245-3.541-0.064-4.672-0.971-3.595-3.904-6.389-7.499-7.136-1.045-0.213-2.944-0.213-4 0-3.637 0.747-6.645 3.68-7.563 7.371-0.245 1.003-0.245 3.445 0 4.448 0.608 2.443 2.187 4.683 4.256 6.016 0.405 0.267 0.896 0.544 1.099 0.629 0.448 0.192 0.544 0.352 0.629 1.141 0.053 0.48 0.040 0.619-0.075 0.619-0.075 0-0.619-0.235-1.195-0.512l-0.053-0.040c-3.296-1.621-5.408-4.365-6.176-8.016-0.192-0.941-0.224-3.189-0.040-4.053 0.48-2.32 1.397-4.133 2.923-5.739 2.197-2.316 5.024-3.541 8.169-3.54zM15.999 7.171c0.545 0.005 1.071 0.053 1.475 0.141 3.712 0.827 6.347 4.544 5.835 8.232-0.203 1.485-0.715 2.707-1.621 3.84-0.448 0.573-1.536 1.533-1.728 1.533-0.031 0-0.064-0.363-0.064-0.804v-0.807l0.555-0.661c2.091-2.504 1.941-6.003-0.341-8.299-0.885-0.893-1.909-1.419-3.232-1.661-0.853-0.157-1.035-0.157-1.931-0.011-1.36 0.223-2.413 0.749-3.349 1.675-2.293 2.272-2.443 5.789-0.352 8.296l0.551 0.661v0.811c0 0.448-0.036 0.811-0.080 0.811-0.040 0-0.352-0.213-0.683-0.48l-0.045-0.015c-1.109-0.885-2.091-2.456-2.496-3.996-0.245-0.931-0.245-2.699 0.011-3.627 0.672-2.504 2.517-4.447 5.077-5.359 0.547-0.193 1.511-0.293 2.42-0.281zM15.825 11.157c0.413 0 0.827 0.080 1.125 0.237 0.651 0.337 1.184 0.993 1.387 1.679 0.619 2.104-1.611 3.947-3.627 3.005h-0.020c-0.949-0.441-1.461-1.275-1.472-2.36 0-0.977 0.544-1.828 1.483-2.327 0.299-0.156 0.712-0.235 1.124-0.235zM15.811 17.461c1.317-0.005 2.275 0.465 2.627 1.293 0.264 0.619 0.165 2.576-0.291 5.736-0.309 2.208-0.48 2.765-0.907 3.141-0.587 0.52-1.419 0.664-2.208 0.384h-0.004c-0.955-0.343-1.16-0.807-1.552-3.525-0.455-3.16-0.555-5.117-0.291-5.736 0.349-0.821 1.299-1.288 2.625-1.293z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var ApplePodcastIcon = __vue_component__;
export { ApplePodcastIcon as default };